export default __webpack_public_path__ + "static/media/MyPlanimg2.5311bb3f.jpg";